import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FaxBackResponse } from '../models/faxback.model';
import { UpdateUserServiceCode } from '@voice/utils';

export interface FaxAuditChange {
  domain: string;
  userId: string;
  username: string;
  name: string;
  faxType: string;
  currentCode: string;
  newCode: string;
  outcome: 'proposed' | 'applied' | 'failed';
}

export interface FaxAuditSyncRun {
  status: string;
  isDryRun: boolean;
  completedAt: string;
  totalDomains: number;
  processedDomains: number;
  changeCount: number;
  failedCount: number;
  skippedCount: number;
  errors: string[];
  changes: FaxAuditChange[];
}

@Injectable({ providedIn: 'root' })
export class FaxAuditService {
  constructor(private http: HttpClient) {}

  public getAccounts(domains: string[]): Observable<FaxBackResponse> {
    const url = `${environment.voiceAPIConfig.uri}/fax-audit/run`;
    return this.http.post<FaxBackResponse>(url, { domains });
  }

  public updateUsersServiceCode(
    accounts: UpdateUserServiceCode[]
  ): Observable<UpdateUserServiceCode[]> {
    const url = `${environment.voiceAPIConfig.uri}/fax-audit/service-code`;
    return this.http.patch<UpdateUserServiceCode[]>(url, accounts);
  }

  /** What the scheduled fax audit did on its last run; null before the first. */
  public getLastSyncRun(): Observable<FaxAuditSyncRun | null> {
    return this.http.get<FaxAuditSyncRun | null>(
      `${environment.voiceAPIConfig.uri}/fax-audit/last-run`
    );
  }

  /** Writes the rows the last recording-only run proposed. */
  public applyLastSyncRun(): Observable<{ appliedCount: number; failedCount: number }> {
    return this.http.post<{ appliedCount: number; failedCount: number }>(
      `${environment.voiceAPIConfig.uri}/fax-audit/last-run/apply`,
      {}
    );
  }
}
